import { makeStyles, Theme } from "@material-ui/core";
import { createStyles } from "@material-ui/core/styles";
import { COLORS } from "constants/colors";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      marginBottom: "10px",
    },
    title: {
      fontSize: 24,
      marginTop: 5,
      fontWeight: "bold",
      color: COLORS.secondary,
      [theme.breakpoints.down("xs")]: {
        fontSize: 18,
      },
    },
    search: {
      marginLeft: "auto",
    },
    filterStyled: {
      display: "block",
      color: COLORS.primary,
      marginLeft: "10px",
    },
  })
);
